import { render, staticRenderFns } from "./xysq-add-or-update.vue?vue&type=template&id=a1d48866&scoped=true"
import script from "./xysq-add-or-update.vue?vue&type=script&lang=js"
export * from "./xysq-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./xysq-add-or-update.vue?vue&type=style&index=0&id=a1d48866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d48866",
  null
  
)

export default component.exports